import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  tabContent: {
    padding: theme.spacing(4),
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0)
    },
  },
  syncTab: {
    background: theme.palette.primary.main,
    color: "#fff"
  },
}));
